export enum TProductVoucherValue {
    value = 1,
    percentage = 2,
}

export enum TProductVoucherExpired {
    quantity = 1,
    date = 2,
}

export type TProductVoucher = {
    id?: string;
    productId: string;
    voucherIdentifier: string;
    valueType: TProductVoucherValue;
    value: number | string;
    startDate: Date;
    expiredType: TProductVoucherExpired;
    maxQuantity?: number | null;
    endDate?: Date | null;
    isOffersAll: boolean;
    productPrices: string[];
}

export type TProductVoucherApply = {
    voucherId: string;
    voucherIdentifier: string;
    valueType: TProductVoucherValue;
    value: number;
}